"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GlobalEventTracker = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var EVENT_ACTION_MAP = {
  click: 'Clicked',
  focus: 'Focused',
  blur: 'Blurred',
  change: 'Changed',
  keydown: 'Key Down'
};
var eventKeys = Object.keys(EVENT_ACTION_MAP);

function getActionName(eventType, isEnterKeyDownEvent) {
  if (eventType === 'keydown' && isEnterKeyDownEvent) return 'Enter Key Down';
  return EVENT_ACTION_MAP[eventType];
}

function camelize(str) {
  return str.replace(/\s(.)/g, function (w) {
    return w.toUpperCase();
  }).replace(/\s/g, '').replace(/^(.)/, function (w) {
    return w.toLowerCase();
  });
}

function getElementWithDataAttr(attributeName, targetElement) {
  var _maybeSelectedElement, _camelize;

  var maybeSelectedElementWithAttributeWithAttribute = targetElement;

  while (maybeSelectedElementWithAttributeWithAttribute && maybeSelectedElementWithAttributeWithAttribute.getAttribute("data-".concat(attributeName)) === null) {
    maybeSelectedElementWithAttributeWithAttribute = maybeSelectedElementWithAttributeWithAttribute.parentElement;
  }

  var selectedElementWithAttribute = (_maybeSelectedElement = maybeSelectedElementWithAttributeWithAttribute) !== null && _maybeSelectedElement !== void 0 ? _maybeSelectedElement : document.querySelector("[data-".concat(attributeName, "]"));
  var camelAttributeName = (_camelize = camelize(attributeName)) !== null && _camelize !== void 0 ? _camelize : '';

  if (selectedElementWithAttribute) {
    var _selectedElementWithA;

    var attributeData = (_selectedElementWithA = selectedElementWithAttribute.getAttribute("data-".concat(attributeName))) !== null && _selectedElementWithA !== void 0 ? _selectedElementWithA : '';
    return attributeData !== '' ? attributeData : "".concat(camelAttributeName, "_empty");
  }

  return "".concat(camelAttributeName, "_not_found");
}

var GlobalEventTracker = /*#__PURE__*/(0, _createClass2.default)(function GlobalEventTracker(fetcher, isDev, additionalData) {
  var _this = this;

  (0, _classCallCheck2.default)(this, GlobalEventTracker);
  (0, _defineProperty2.default)(this, "additionalData", void 0);
  (0, _defineProperty2.default)(this, "boundedContext", null);
  (0, _defineProperty2.default)(this, "entity", null);
  (0, _defineProperty2.default)(this, "fetcher", void 0);
  (0, _defineProperty2.default)(this, "isDev", void 0);
  (0, _defineProperty2.default)(this, "getElementWithEvent", function (elementToCheck, elementToFinish, eventType) {
    var _elementToCheck$getAt;

    if (elementToCheck === elementToFinish || !elementToCheck) {
      return null;
    } else if ((_elementToCheck$getAt = elementToCheck.getAttribute('data-track-type')) !== null && _elementToCheck$getAt !== void 0 && _elementToCheck$getAt.includes(eventType)) {
      return elementToCheck;
    } else {
      return _this.getElementWithEvent(elementToCheck.parentElement, elementToFinish, eventType);
    }
  });
  (0, _defineProperty2.default)(this, "eventHandler", /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(e) {
      var element, hasEnterKeydownFilter, isKeyDownEvent, isEnterKeyDownEvent, eventName, params;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (e.target instanceof HTMLElement && e.currentTarget instanceof HTMLElement && eventKeys.includes(e.type)) {
                element = _this.getElementWithEvent(e.target, e.currentTarget, e.type);
                hasEnterKeydownFilter = (element === null || element === void 0 ? void 0 : element.dataset.eventFilter) === 'enterKeydownFilter';
                isKeyDownEvent = e.type === 'keydown';
                isEnterKeyDownEvent = isKeyDownEvent && e.key === 'Enter';

                if (element && (!isKeyDownEvent || !hasEnterKeydownFilter || isEnterKeyDownEvent)) {
                  _this.boundedContext = getElementWithDataAttr('bounded-context', element);
                  _this.entity = getElementWithDataAttr('entity', element);
                  eventName = camelize("".concat(_this.boundedContext, ".").concat(_this.entity, ".").concat(element.dataset.elementName).concat(getActionName(e.type, isEnterKeyDownEvent)));
                  params = _objectSpread(_objectSpread(_objectSpread({}, _this.additionalData), element.dataset), {}, {
                    trackType: e.type,
                    eventName: eventName,
                    boundedContext: _this.boundedContext,
                    entity: _this.entity
                  });
                  delete params.eventFilter;

                  _this.logEvent(params);
                }
              }

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
  (0, _defineProperty2.default)(this, "logEvent", /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(params) {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (_this.isDev) {
                // eslint-disable-next-line no-console
                console.log('LogEvent: ', params);
              } else {
                _this.fetcher(params);
              }

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }());
  (0, _defineProperty2.default)(this, "startTracking", function (eventsToTrack) {
    eventsToTrack.forEach(function (eventType) {
      document.body.addEventListener(eventType, _this.eventHandler, true);
    });
  });
  this.additionalData = additionalData;
  this.fetcher = fetcher;
  this.isDev = isDev;
});
exports.GlobalEventTracker = GlobalEventTracker;
var _default = GlobalEventTracker;
exports.default = _default;